import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { RailOuter, RailInner } from "./styles";

export const SliderRail = ({ getRailProps, disabled = false }) => {
  return (
    <Fragment>
      <RailOuter $disabled={disabled} {...getRailProps()} />
      <RailInner />
    </Fragment>
  );
}

SliderRail.propTypes = {
  getRailProps: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};
